import { Modal as DefaultModal } from 'components';
import styled from 'styled-components';

export const Modal = styled(DefaultModal)`
  margin: 0 auto;
  max-width: 35.625rem;
`;
